module.exports = __webpack_public_path__ + "resources/images/regiobank-b8ad6dc92f04a13ec611b233cc0dbaad-cache.png";